import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-menu-icon',
  standalone: true,
  templateUrl: './menu-icon.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuLogoComponent {
}
